import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/apiClient";
import { useSeoSettings } from "../context/SeoContext";
import { Seo } from "./Seo";

/**
 * Fetches computed SEO meta for the current route from the backend and applies it.
 * Mounted once in the store layout so every public page is optimized automatically.
 */
export const RouteSeo = () => {
  const location = useLocation();
  const { settings } = useSeoSettings();
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    let active = true;
    api
      .get(`/seo/meta?path=${encodeURIComponent(location.pathname)}`)
      .then((r) => active && setMeta(r.data))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [location.pathname]);

  if (!meta) return null;
  return <Seo {...meta} siteName={settings?.site_name} />;
};
